module.exports = __webpack_public_path__ + "static/NightInTheWoods9-1ed59c508d497a911b6f16d9d6a4d613.png";